var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-2",attrs:{"id":"page-dashboard"}},[_c('div',{staticClass:"dashboard-container"},[_c('div',{staticClass:"instance-grid"},_vm._l((_vm.instances),function(instance,index){return _c('DashboardInstanceStatus',{key:index,attrs:{"instance":instance}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }